/*
 * Content-protection deterrent (owner request). Blocks the casual save/copy
 * gestures on the storefront; determined users (dev tools, direct CDN URL,
 * JS disabled) and bots/crawlers are unaffected — see eros-content-protect.css.
 * Deferred + a few delegated listeners: no measurable page-load cost.
 */
(function () {
  'use strict';

  function inField(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('input, textarea, select, [contenteditable]')
    );
  }

  function onMedia(el) {
    return !!(el && el.closest && el.closest('img, picture, video'));
  }

  // Right-click "Save image as…" — blocked on media only (kept everywhere else,
  // so "open link in new tab" etc. still work).
  document.addEventListener('contextmenu', function (e) {
    if (onMedia(e.target)) e.preventDefault();
  });

  // Drag an image out of the page to the desktop/another app to save it.
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });

  // Copy/cut of page text — still allowed inside form fields the shopper types
  // into (so search, cart note, address, etc. keep working).
  ['copy', 'cut'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!inField(e.target)) e.preventDefault();
    });
  });
})();
